import { render, staticRenderFns } from "./_base-pagination.vue?vue&type=template&id=34a1d817"
import script from "./_base-pagination.vue?vue&type=script&lang=js"
export * from "./_base-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports